import React from 'react';
import { Section } from './ui/Section';
export function PDFPreview() {
  return <Section className="py-0 md:py-0" data-id="element-81">
      <div className="relative rounded-3xl overflow-hidden bg-[#2D2D2D] p-8 md:p-16 text-center" data-id="element-82">
        {/* Decorative background circles */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-[#D4735E]/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-83" />
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#D4735E]/20 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-84" />

        <div className="relative z-10 flex flex-col items-center" data-id="element-85">
          {/* PDF Mockup Visualization */}
          <div className="w-full max-w-sm aspect-[3/4] bg-white rounded shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500 flex flex-col overflow-hidden mb-8" data-id="element-86">
            <div className="h-2 bg-[#D4735E]" data-id="element-87" />
            <div className="flex-1 p-8 flex flex-col items-center justify-center bg-[#FAF8F5]" data-id="element-88">
              <div className="w-16 h-16 rounded-full bg-[#D4735E]/10 flex items-center justify-center mb-6" data-id="element-89">
                <span className="text-2xl" data-id="element-90">✨</span>
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#2D2D2D] mb-2" data-id="element-91">
                Plan NoMásTóxicos™
              </h3>
              <p className="text-sm text-[#666666] uppercase tracking-widest" data-id="element-92">
                Guía Práctica
              </p>

              <div className="w-full mt-12 space-y-3 opacity-30" data-id="element-93">
                <div className="h-2 bg-gray-300 rounded w-full" data-id="element-94" />
                <div className="h-2 bg-gray-300 rounded w-5/6" data-id="element-95" />
                <div className="h-2 bg-gray-300 rounded w-4/6" data-id="element-96" />
              </div>
            </div>
          </div>

          <p className="text-white/60 text-sm tracking-widest uppercase" data-id="element-97">
            PDF Preview
          </p>
        </div>
      </div>
    </Section>;
}